<div class="twc-d-flex height-100 object-browser flex-direction-column">
    <div class="object-browser-header twc-d-flex flex-direction-column">
        <div class="twc-d-flex">
            <cw-object-browser-filter class="width-100" *ngIf="selectedView" [filters]="selectedView.filters"
                [areFiltersDisabled]="hasToShowSelectedElementsOnly" [reset]="resetFilter$"
                (filterChange)="filterChanged($event)">
            </cw-object-browser-filter>

            <div class="twc-d-flex views-and-extra-buttons">
                <button *ngIf="secondaryButton" class="twc-button twc-button-primary twc-button-icon"
                    [attr.qaid]="secondaryButton.qaid" [twcTooltip]="secondaryButton.tooltip | translate"
                    placement="bottom" (click)="secondaryButton.onClick()">
                    <twc-icon [shape]="secondaryButton.icon" [size]="32"></twc-icon>
                </button>
                <ng-container *ngIf="browserViews.length > 1">
                    <div *ngFor="let view of browserViews">
                        <button class="twc-button twc-button-secondary twc-button-icon button-view"
                            [twcTooltip]="view.tooltip | translate" placement="bottom"
                            [ngClass]="{'selected-view': view ===selectedView}" (click)="changeView(view)">
                            <twc-icon [shape]="view.icon" [size]="32"></twc-icon>
                        </button>
                    </div>
                </ng-container>

                <div class="twc-mb-1 twc-ml-4" qaid="icon_refresh-list">
                    <cw-refresh-button [isRefreshing]="isDataLoading()" (refresh)="dataRefreshed()"></cw-refresh-button>
                </div>
                <ng-container *ngIf="mainButton">
                    <button *ngIf="!mainButton.children" class="twc-button twc-button-alternative twc-ml-4"
                        (click)="onClickMainButton(mainButton.id)" qaid="button_secondary-action">
                        {{ mainButton.label | translate }}
                    </button>

                    <twc-menu-wrapper *ngIf="mainButton.children">
                        <button class="twc-button twc-button-alternative twc-ml-4">
                            <span class="twc-button-label"> {{ mainButton.label | translate }}</span>
                            <twc-icon shape="drop-down"></twc-icon>
                        </button>
                        <twc-menu [position]="'bottom-left'">
                            <ng-container *ngFor="let option of mainButton.children">
                                <twc-menu-option (click)="onClickMainButton(option.id)">
                                    {{ option.label | translate }}
                                </twc-menu-option>
                            </ng-container>
                        </twc-menu>
                    </twc-menu-wrapper>
                </ng-container>

            </div>
        </div>

        <div class="twc-d-flex selection-footer">
            <div footer *ngIf="isElementSelectFilterShown()">
                <cw-object-browser-selection [selectionResources]="footerSelectionResources"
                    (clearSelection)="onClearSelection()" (delete)="onDelete()"
                    (showSelectedElementsChange)="onShowSelectedElementsChanged($event)"
                    (createProject)="onCreateProject()">
                </cw-object-browser-selection>
            </div>
        </div>
    </div>

    <ng-container *ngIf="data && !isDataLoading(); else loadingTemplate">
        <ng-container *ngIf="!isMapView(); else mapView">
            <div *ngIf="data.results?.length; else noResults" class="results">
                <div class="detail" [ngClass]="{'detail-card-vertical': isGridView()}" *ngIf="!isListView()">
                    <cw-card *ngFor="let item of data.results" [catalogObject]="item.catalogObject"
                        [shouldShowCheckbox]="hasToShowCheckbox(item)"
                        [cardSecondaryMenuOptions]="item.secondaryMenuOptions" [iconDetail]="item.iconDetail"
                        [isVertical]="!isDetailView()" [checked]="item.selected" (cardCheck)="onElementSelected($event)"
                        (objectClick)="onObjectClicked($event)"
                        (secondaryMenuClick)="onMenuOptionClick($event, item.catalogObject)">
                    </cw-card>
                </div>

                <div class="list-view" *ngIf="isListView()">
                    <cw-grid [data]="data.results" [columns]="columnDataList" [isMultiselection]="isMultiSelection"
                        (secondaryMenuClick)="onMenuOptionClick($event.menuOption,$event.row.catalogObject)"
                        (elementCheck)="onElementSelected($event)"
                        (selectedRowChange)="onObjectClicked($event.catalogObject)" [catalogObjectType]="dataType"
                        (linkFieldClick)="onLinkFieldClick($event.row)" (checkedAllChange)="onCheckedAllChanged()">
                    </cw-grid>
                </div>

                <cw-paginator *ngIf="data.count" [pageSize]="pagination.pageSize" [total]="data.count"
                    [current]="pagination.currentPage" (currentChange)="onCurrentPageChanged($event)">
                </cw-paginator>

            </div>
        </ng-container>

        <ng-template #mapView>
            <cw-sites-map [jobSitesList]="jobSiteList" (selectedJobSite)="onObjectMapClicked($event)"></cw-sites-map>
        </ng-template>

    </ng-container>

</div>

<ng-template #loadingTemplate>
    <div class="position-absolute width-100 twc-d-flex align-center justify-content-center loader-container">
        <twc-loader size="large"></twc-loader>
    </div>
</ng-template>

<ng-template #noResults>
    <div *ngIf="!isDataLoading()" class="no-results">
        <span>{{'OBJECT_BROWSER.NO_RESULTS' | translate}}</span>
    </div>
</ng-template>